__turbopack_context__.v({
  "ctaContainer": "QuickActionPopup-module-scss-module__CmidXG__ctaContainer",
  "description": "QuickActionPopup-module-scss-module__CmidXG__description",
  "header": "QuickActionPopup-module-scss-module__CmidXG__header",
  "icon": "QuickActionPopup-module-scss-module__CmidXG__icon",
  "main": "QuickActionPopup-module-scss-module__CmidXG__main",
});
